function HiringOrganizationLayout({ column }) {
  return (
    <div className="item d-flex flex-column">
      {column.map((data) => {
        return (
          <figure key={data.id} className="d-flex justify-content align-items">
            <img src={data.img_url} alt={data.alt_name} width={130} height={60} />
          </figure>
        );
      })}
    </div>
  );
}
export default HiringOrganizationLayout;
